import { createApp } from 'vue';
import './style.css';
import { createPinia } from 'pinia';
import App from './DynamicApp.vue';
import '@vant/touch-emulator';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';

const pinia = createPinia();
createApp(App).use(pinia).mount('#app');
